import axios from "axios";
import { getAuth } from "firebase/auth";

const BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

export default class HashtagService {

  static async searchHashtags(query) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken();

      const response = await axios.get(`${BASE_URL}/search_hashtags`, {
        params: { query },
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      if (response.data.error) {
        throw new Error(response.data.error);
      }

      console.log("📡 Полученные хэштеги:", response.data.hashtags);
      return response.data.hashtags;
    } catch (error) {
      console.error("❌ Ошибка при получении хэштегов:", error.response?.data || error.message);
      return [];
    }
  }

 /**
   * Обновляет только хэштеги пользователя.
   * @param {string[]|string} hashtags - массив тегов или строка через запятую
   * @returns {Promise<boolean>} true — успех, false — ошибка
   */
  static async updateUserHashtags(hashtags) {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("Пользователь не авторизован");

      const token = await user.getIdToken(true);

      // ✅ Нормализация: всё превращаем в строки
      const list = Array.isArray(hashtags)
        ? hashtags.map(h =>
            typeof h === "string"
              ? h
              : (h?.name || h?.id || String(h)) // поддержим объекты
          )
        : String(hashtags || "").split(",");

      const clean = [...new Set(
        list
          .map(s => String(s).trim())  // гарантируем строку
          .filter(s => s.length > 0)
      )].slice(0, 30);

      const { data } = await axios.post(
        `${BASE_URL}/update_profile`,
        { updates: { hashtags: clean } },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data?.error) throw new Error(String(data.error));
      console.log("✅ Хэштеги обновлены:", clean);
      return true;
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message;
      console.error("❌ Ошибка при обновлении хэштегов:", msg);
      throw new Error("Не удалось обновить хэштеги");
    }
  }

}
